function setTitle(title) {
  document.title = title || "老学员报名专属活动";
}

export default {
  setTitle,
};
